import React from 'react';
import './Properties_card.css'
import Icon1 from '../../Assets/Location icon.svg'
import Icon2 from '../../Assets/rooms icon.svg'
import Icon3 from '../../Assets/bathroom icon.svg'
import Icon4 from '../../Assets/area icon.svg'


const Properties_Card = (props) => {
    return ( 
        <div className='properties_card_div'>
            <img className='properties_card_img' src={props.img} alt="" />
            <div className='properties_card_div1'>
                <div className='properties_card_div2'>
                    <h1 className='properties_card_text1'>{props.price}</h1>
                    <h2 className='properties_card_text2'>{props.name}</h2>
                    <div className='properties_card_div3'>
                        <img className='.properties_card_icons' src={Icon1} alt="" />
                        <h6 className='properties_card_text3'>{props.location}</h6>
                    </div>
                </div>
                <div className='properties_card_div4'>
                    <div className='properties_card_div5'>
                       <img className='.properties_card_icons' src={Icon2} alt="" />
                        <h6 className='properties_card_text3'>{props.rooms}</h6>
                        </div>
                        <div className='properties_card_div5'>
                       <img className='.properties_card_icons' src={Icon3} alt="" />
                        <h6 className='properties_card_text3'>{props.bathrooms}</h6>
                        </div>
                        <div className='properties_card_div5'>
                       <img className='.properties_card_icons' src={Icon4} alt="" />
                        <h6 className='properties_card_text3'>{props.area}</h6>
                        </div>
                </div>
            </div>

        </div>
     );
}
 
export default Properties_Card;